import React, {Component} from "react";
import BarGroup from './BarGroup';

class BarChart extends Component {
    state = {
        data: this.props.data,
        max: this.props.max
    }
  
    render() {
        let barGroups = this.state.data.map((data, index) => 
            <div key={index}>
                <BarGroup data={data} index={index} max={this.state.max}/>
            </div>
        );
        return (
            <div class="bar-chart">
                {barGroups}
            </div>
        );
    }
}

export default BarChart;